import {get} from 'lodash';

import {getCacheKey, getRecordCacheKey} from '/util/records.util';

export default (
  state = {},
  {recordsName, recordsParams, recordParams, recordData, recordExtra}: any,
) => {
  const reportKey = getCacheKey({
    recordsName,
    recordsParams,
  });
  const recordKey = getRecordCacheKey({reportKey, recordParams});

  return {
    ...state,
    allReportRecordData: {
      ...get(state, 'allReportRecordData', {}),
      [reportKey]: {
        ...get(state, `allReportRecordData.${reportKey}`, {}),
        [recordKey]: {
          ...recordData,
          __extras: recordExtra,
        },
      },
    },
  };
};
